import React from 'react';

interface DillButtonProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  label?: string;
  variant?:
    | 'primary'
    | 'secondary'
    | 'danger'
    | 'ghost'
    | 'icon-default'
    | 'icon-red'
    | 'icon-blue'
    | 'ghost-blue'
    | 'ghost-yellow';
  icon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  isLoading?: boolean;
  isDisabled?: boolean;
  type?: 'button' | 'submit';
  height?: number | string;
  width?: number | string;
  className?: string;
  centered?: boolean;
}

export const DillButton = ({
  onClick,
  label,
  variant = 'primary',
  icon,
  rightIcon,
  isLoading,
  isDisabled,
  type = 'button',
  height,
  width,
  className = '',
  centered,
}: DillButtonProps) => {
  const cls = {
    primary: 'bg-blue-500 hover:bg-blue-700 text-white border-transparent',
    secondary: 'bg-white hover:bg-gray-50 text-gray-600 border-gray-200',
    danger: 'bg-red-500 hover:bg-red-600 text-white border-transparent',
    ghost: 'bg-transparent hover:bg-gray-50 text-gray-500 hover:text-gray-700 border-transparent',
    'ghost-blue':
      'bg-transparent hover:bg-blue-100 text-blue-500 hover:text-blue-700 border-transparent',
    'ghost-yellow':
      'bg-amber-50 hover:bg-amber-100 text-amber-800 border-amber-200 hover:border-amber-300',
    'icon-default': 'bg-white border-gray-200 text-gray-400 hover:text-gray-600 hover:bg-gray-50',
    'icon-red': 'bg-red-50 border-red-200 text-red-400 hover:bg-red-100',
    'icon-blue': 'bg-white border-blue-200 text-blue-500 hover:bg-blue-100',
  }[variant];

  if (!label) {
    return (
      <button
        type={type}
        onClick={(e) => {
          onClick(e);
        }}
        disabled={isDisabled || isLoading}
        style={{ height, width }}
        className={`${
          !height && !width ? 'w-7 h-7' : ''
        } flex items-center justify-center border rounded-md cursor-pointer transition-colors shrink-0 ${cls} disabled:opacity-50 disabled:cursor-not-allowed ${
          centered ? ' mx-auto' : ''
        } ${className}`}>
        {isLoading ? (
          <span className="w-3 h-3 border border-current border-t-transparent rounded-full animate-spin" />
        ) : (
          <div>{icon}</div>
        )}
      </button>
    );
  }

  return (
    <button
      type={type}
      onClick={(e) => {
        onClick(e);
      }}
      disabled={isDisabled || isLoading}
      style={{ height, width }}
      className={`inline-flex items-center gap-1.5 text-nowrap text-center justify-center ${
        !height ? 'h-[34px]' : ''
      } px-3.5 text-xs font-medium rounded-lg border cursor-pointer transition-colors ${cls} disabled:opacity-50 disabled:cursor-not-allowed ${
        centered ? 'mx-auto' : ''
      } ${className}`}>
      {isLoading ? (
        <span className="w-3 h-3 border border-current border-t-transparent rounded-full animate-spin" />
      ) : (
        <>{icon && <div>{icon}</div>}</>
      )}
      {label}
      {!isLoading && rightIcon && <div>{rightIcon}</div>}
    </button>
  );
};
